import axios from "axios";
import { encodeBody, encodeQueryParams } from "./client";
import { baseUrl } from "./config";

export const getStaff: any = (params:any) => {
  const path = `${baseUrl}/api/users/staff${encodeQueryParams({ clubId: params.clubId })}`;
  return axios({
    method: 'GET',
    url: path,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then(response => response.data.data).catch((err) => console.error('Error in getStaff:', err));
};

export const getUser: any = () => {
  const path = `${baseUrl}/api/users/account`;
  return axios({
    method: 'GET',
    url: path,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then(response => response.data.data);
};

export const updateUser: any = (params:any) => {
  const path = `${baseUrl}/api/users/account`;
  return axios({
    method: 'PUT',
    url: path,
    data: encodeBody(params),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then(response => response.data.data);
};

export const getUserNotes: any = () => {
  const path = `${baseUrl}/api/users/notes`;
  return axios({
    method: 'GET',
    url: path,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then(response => response.data);
};

export const updateUserNotes: any = (params:any) => {
  const path = `${baseUrl}/api/users/notes`;
  return axios({
    method: 'POST',
    url: path,
    data: encodeBody(params),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then(response => response.data);
};

export const getUserAvatar: any = (params:any) => {
  const path = `${baseUrl}/api/users/avatar${encodeQueryParams({ userId: params.userId })}`;
  return axios({
    method: 'GET',
    url: path,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    responseType: 'arraybuffer',
  }).then((response: any) => {
    const image = btoa(new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte), ''));
    return `data:${response?.headers['content-type']?.toString()?.toLowerCase()};base64,${image}`;
  });
};

export const uploadAvatar: any = (params:any) => {
  const path = `${baseUrl}/api/users/avatar`;
  const data = new FormData();
  data.append('avatar', params.avatar);
  return axios({
    method: 'POST',
    url: path,
    data,
    onUploadProgress: params.onUploadProgress,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }).then(response => response.data.data);
};